const episodesOfCareMessages = {
  pageTitle: {
    title: 'Episodes of Care',
    subTitle:
      'Explore the services and cost associated with certain planned procedures',
  },
  SUMMARY_CARDS: {
    EPISODES: 'No of Episodes',
    CLAIMS: 'No of Claims',
    COHORT_COST: 'Cohort Cost',
    TOTAL_COST: 'Total Cost',
    OPPORTUNITY_COST: 'Opportunity Cost',
    OPPORTUNITY_COST_HOVER:
      'Value of the best alternative use of healthcare resources forgone due to the provision of emergency care',
    MEMBERS: 'Cohort Members',
  },
  EPISODES_TABLE: {
    TITLE: 'Episodes of Care',
    SUB_TITLE: 'Click on an episode name for additional details',
  },
  EPISODE_SELECTED: {
    TITLE: 'Episodes of Care for',
    SUB_TITLE:
      'Explore the services and cost associated with the indicated procedure',
  },
  COST_TREND: {
    SUB_TITLE: 'You can view and compare the cost of the episode selected here',
  },
  COST_BREAK_DOWN: {
    TITLE: 'Episode Treatment Details',
    SUB_TITLE:
      'Showing the cost breakdown of pre operative, surgery and post operative treatments',
  },
  CARE_QUALITY : {
    TITLE: 'Quality Measures',
    SUB_TITLE: 'Showing the quality measures of the episode',
    EMPTY_DATA: 'The selected measure does not have any quality measures'
  },
  MEMBER_CLAIMS_TABLE: {
    TITLE: 'Member Claims Details',
    SUB_TITLE:
      "To see more about a member's claims, click the dropdown icon next to the member ID.  To get a complete medical history for the member, click on the member ID itself",
  },
  MEMBER_PAGE_BREAD_CRUMBS: {
    text: 'text',
    TITLE: 'EPISODES-OF-CARE',
    MEMBER_CLAIMS: 'MEMBER_CLAIMS',
  },
  NO_DATA_CONTENT: 'The selected group does not have any episodes of care',
};

export default episodesOfCareMessages;
